"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getMuiDialog = getMuiDialog;
var _styles = require("@mui/material/styles");
function getMuiDialog(palette) {
  return {
    defaultProps: {
      // @ts-ignore missing in defaultProps type
      'data-testid': 'required'
    },
    styleOverrides: {
      root: {
        '.MuiBackdrop-root': {
          backgroundColor: (0, _styles.alpha)(palette.common.black, 0.4)
        },
        '.MuiDialog-paperWidthMd': {
          width: '800px'
        },
        '.MuiPaper-root': {
          '.MuiDialogActions-root': {
            padding: '12px 0 0'
          },
          '.MuiDialogContent-root': {
            '.MuiTypography-root': {
              color: palette.common.black
            },
            padding: '12px 0 0'
          },
          '.MuiDialogTitle-root': {
            alignItems: 'center',
            display: 'flex',
            justifyContent: 'space-between',
            minHeight: '28px',
            padding: '0'
          },
          borderRadius: '4px',
          boxShadow: '0px 2px 6px rgba(51, 51, 51, 0.15)',
          padding: 20
        }
      }
    }
  };
}